import { atom } from 'recoil';
import localForageEffect from './effects/localForageEffect';
import setDriverIdsToSocketServerEffect from './effects/setDriverIdsToSocketServerEffect';

export interface DriverOption {
  value: number;
  item: string;
  label: string;
  deleted: boolean;
}

export const driverOptionsAtom = atom<DriverOption[]>({
  key: 'driverOptions',
  default: [],
  effects: [localForageEffect('driverIds'), setDriverIdsToSocketServerEffect()],
});
